import { DataAnalyticsClickSource, DataAnalyticsEventLabel } from '../../shared/mb-constants'

export const MB_ANALYTICS_DATA_FEATURE = 'mbAnalytics'

export interface MbStateWithAnalyticsContext {
  [MB_ANALYTICS_DATA_FEATURE]: AnalyticsDataState;
}

export interface AnalyticsDataState {
  cart: {
    mostRecentAddToCartSource: AddToCartSource;
  };
}

export interface AddToCartSource {
  id: DataAnalyticsClickSource;
  eventLabel: DataAnalyticsEventLabel;
}
